export default class ShowTargetsController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    schoolCommonRoom
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.schoolCommonRoom = schoolCommonRoom;
  }

  edit() {
    this.$mdDialog.hide();
    this.$state.go('modules.settings.step5');
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
